<template>
  <div class="text-center mb-4">
    <span class="h5 fw-bold">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'FormCaption',
  props: {
    text: {
      type: [String, null],
      required: true
    },
  }
}
</script>
